import { Controller } from "@hotwired/stimulus"
import _ from "underscore"

// Connects to data-controller="scroll-for-more"
export default class extends Controller {
  connect() {
    this.scrollForMore();
  }

  scrollForMore() {
    const element = document.getElementsByClassName("photo-strip")[0];
    const startOverlay = document.getElementsByClassName("left-overlay")[0];
    const endOverlay = document.getElementsByClassName("right-overlay")[0];

    showHideShadows();
    element.addEventListener("scroll", _.throttle(showHideShadows, 200, {leading: true, trailing: true}));
    addEventListener("resize", _.throttle(showHideShadows, 200, {leading: true, trailing: true}));

    function showHideShadows() {
      const fullStripWidth = element.scrollWidth;
      const viewWidth = element.parentElement.offsetWidth;
      const viewLeftEdge = element.scrollLeft;
      const viewRightEdge = viewLeftEdge + viewWidth;

      // If the view is wider than the strip, hide both overlays
      if (viewWidth > fullStripWidth) {
        startOverlay.classList.add("hidden");
        endOverlay.classList.add("hidden");
      } else {
        endOverlay.classList.remove("hidden");
      }

      // At start
      if (viewLeftEdge == 0) {
        startOverlay.classList.add("hidden");
        return;
      }
      // Not at start
      if (viewLeftEdge > 0) {
        startOverlay.classList.remove("hidden");
      }

      // Not at end
      if (viewRightEdge < fullStripWidth) {
        endOverlay.classList.remove("hidden");
        return;
      }

      // At end
      if (viewRightEdge >= fullStripWidth) {
        endOverlay.classList.add("hidden");
      }
    }
  }
}
